import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { getField, updateField } from 'vuex-map-fields';

import { normalizeAddressString } from '@/helpers/normalizeAddress';
import ApiService from '@/services/ApiService';

import { RootState } from './';

type State = {
  editedOrderId?: string;

  freightStatusesOfOrder: {
    new?: number;
    notNew?: number;
  };

  editedDeliveryAddress?: string;
  originalDeliveryAddress?: string;
};

const state: State = {
  editedOrderId: undefined,

  freightStatusesOfOrder: {
    new: undefined,
    notNew: undefined
  },

  editedDeliveryAddress: undefined,
  originalDeliveryAddress: undefined
};

const actions: ActionTree<State, RootState> = {
  async editOrderDeliveryAddress(
    { commit },
    { orderId, deliveryAddress }: { orderId: string; deliveryAddress: string }
  ) {
    const response = await ApiService.getFreightStatusesOfOrder(orderId);
    commit('setEditedData', {
      editedOrderId: orderId,
      editedDeliveryAddress: deliveryAddress,
      originalDeliveryAddress: deliveryAddress,
      freightStatusesOfOrder: response.data
    });
  },

  closeOrderDeliveryAddressEditDialog({ commit }) {
    commit('resetState');
  },

  updateDeliveryAddress({ commit }, inputValue: string) {
    if (inputValue) {
      commit('setDeliveryAddress', inputValue);
    }
  },

  async getFreightStatusesOfOrder({ commit }, orderId: string) {
    const response = await ApiService.getFreightStatusesOfOrder(orderId);
    commit('setFreightStatusesOfOrder', response.data);
  },

  async saveDeliveryAddress({ commit, dispatch }) {
    const { data } = await ApiService.saveOrderDeliveryAddress(
      state.editedOrderId,
      state.editedDeliveryAddress
    );
    if (
      data &&
      data.countOfSuccessedUpdates !== undefined &&
      data.countOfFailedUpdates !== undefined
    ) {
      const message =
        `A fuvar címpont frissítések eredménye:<br>` +
        `${data.countOfSuccessedUpdates} sikeres, ` +
        `${data.countOfFailedUpdates} sikertelen<br>`;
      dispatch('alert/success', message, { root: true });
    }
    commit('resetState');
  }
};

const mutations: MutationTree<State> = {
  setEditedData(
    state,
    payload: {
      editedOrderId?: string;
      editedDeliveryAddress?: string;
      originalDeliveryAddress?: string;
      freightStatusesOfOrder: { new?: number; notNew?: number };
    }
  ) {
    state.editedOrderId = payload.editedOrderId;
    state.editedDeliveryAddress = payload.editedDeliveryAddress;
    state.originalDeliveryAddress = payload.originalDeliveryAddress;
    state.freightStatusesOfOrder = payload.freightStatusesOfOrder;
  },

  resetState() {
    state.editedOrderId = undefined;
    state.editedDeliveryAddress = undefined;
    state.originalDeliveryAddress = undefined;
    state.freightStatusesOfOrder = {
      new: undefined,
      notNew: undefined
    };
  },

  setDeliveryAddress(state, deliveryAddress: string) {
    state.editedDeliveryAddress = deliveryAddress;
  },

  updateField
};

const getters: GetterTree<State, RootState> = {
  getAddressSearchResult:
    () =>
    async (value: string): Promise<string[]> => {
      const result: string[] = [];
      if (!value) {
        return result;
      }
      const response = await ApiService.locationSearch(value);

      response.data.result.features.forEach((item: any) => {
        result.push(normalizeAddressString(value, item.properties));
      });

      return result;
    },

  getField
};

export const orderAddress: Module<State, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
